import { useEffect } from 'react';
import { useCustomer } from '../apollo/customer/customer.hooks';

/**
 * Convenience hook to handle changes to customer zip code. Returns previous and
 * current zip codes.
 *
 * @param onChange A callback fired when customer zip changes. It receives the
 * 				   previous and new locations as arguments.
 */
export const useCustomerZipCodeWatcher = (onChange: (prevLocation?: string, curLocation?: string) => void) => {
	const { data, previousData } = useCustomer();
	const currentZipCode = data?.customer?.location?.zipCode;
	const previousZipCode = previousData?.customer?.location?.zipCode;

	useEffect(() => {
		if (currentZipCode && previousZipCode && currentZipCode !== previousZipCode) {
			onChange(previousZipCode, currentZipCode);
		}
		// we don't want to include onChange in the dep array as that can change
		// on re-renders
	}, [currentZipCode, previousZipCode]);

	return {
		currentZipCode: currentZipCode || '',
		previousZipCode: previousZipCode || currentZipCode || null
	};
};
